import {FC} from 'react'

const Error404: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Oh la la!</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        The page you are looking for cannot be found! <br /> Go back to the dashboard or look for
        another page
      </div>
    </>
  )
}

export {Error404}
